module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Bulb#1-6265da485fca6ea5753f773285fff76b.svg";